import { Component, HostBinding, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceService } from '../../../api/app-service.service';
import { ModalPopoverPage } from "../shared/modal-popover/modal-popover.page";
import { environment } from '../../../../environments/environment';
import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { InputSelectModalPointsComponent } from 'src/app/component/input-select-modal-points/input-select-modal-points.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-weblanding',
  templateUrl: './weblanding.page.html',
  styleUrls: ['./weblanding.page.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class WeblandingPage implements OnInit {

  @ViewChild('slider') slider;
  @ViewChild('welcomePackage') welcomePackageTemplate: TemplateRef<any>;

  tempDishcar: any = [];
  slideOpts = {
    initialSlide: 8,
    speed: 400,
    autoplay: true,
    slidesPerView: 4,
  };

  mostPopularDishes: any = [];
  stepTextsAndIcons: any = [];
  metaData: any = {};

  initializeAttempts: number = 0;
  baseURL: string = '';

  iOsLink: string = '';
  androidLink: string = '';

  public welcomeOrderPackage: any = null;

  public welcomePopup: HTMLIonModalElement = null;

  public invitedUserEmail: string = '';

  @ViewChild('rechargeSuccess') rechargeSuccess: TemplateRef<any>;
  public successPayment: any = null;

  @HostBinding('style.--favourite-restaurant-icon')
  public favRestaurantIcon: string = '#ffbc00';

  // social links
  public facebookLink: string = '';
  public facebookUserID: string = '';
  public instagramLink: string = '';
  public instagramUserID: string = '';
  public pinterestLink: string = '';
  public pinterestUserID: string = '';
  public tiktokLink: string = '';
  public tiktokUserID: string = '';
  public youtubeLink: string = '';
  public youtubeUserID: string = '';

  public loadingPointsHistory: boolean = false;
  public pointHistory: any[] = [];
  public totalPointCount: number = 0;
  public selectedRestaurant: any = null;
  public pointsEnabledRestaurantList: any[] = [];

  public show_point_message = false;
  public pointsAreEnabled: boolean = false;
  public selectedRestaurantRechargeIsEnabled: boolean = false;

  public displaySocialButtons: boolean = false;

  public logoUrl = environment.BASE_URL + '/images/restaurant-logo/web/';

  constructor(public appService: AppServiceService, public modalController: ModalController, public router: Router, public route: ActivatedRoute, public sanitizer: DomSanitizer, public translate:TranslateService) {
    this.baseURL = environment.BASE_URL;
    appService.isWebVersion = true;
    appService.themeConfigFor = 'web'
  }

  async ngOnInit() {
    // await this.appService.getRestaurantBySlug('my-chicken');
    // this.getMostPopularDishes();
    // this.fetchMetaData();

    // open welcome package order process if user came from welcome package direct url
    this.route.queryParams.subscribe((params) => {
      if (params && params.welcome_package && params.welcome_package === 'true') {
        this.appService.welcomePackageOnTheWay = true;
        this.appService.welcomePackageOnTheWayFromDirectLink = true;
        // this.presentModal('delivery-type');
      }

      // if(){

      // }
      this.initWebApp();
    });

    this.appService.triggerSettingsLoadedSuccssfulyCallback().subscribe(async (response) => {

      /**Related with customer csv import feature*/
      if (this.appService.appObject.invitedUserEmail) {
        this.invitedUserEmail = this.appService.appObject.invitedUserEmail;
      }

      this.fetchHighlightList();
      this.fetchBranchesList();


      // if user already has authenticated, then get user details object updated
      if (this.appService.appObject.isAuthed)
        await this.appService.getUserDetails({ customer_id: this.appService.appObject.userId });

      if (this.appService.appObject.settings && this.appService.appObject.settings.ios_link) this.iOsLink = this.appService.appObject.settings.ios_link;
      if (this.appService.appObject.settings && this.appService.appObject.settings.android_link) this.androidLink = this.appService.appObject.settings.android_link;

      // check for avilability of welcome order package, and display popup
      if (!this.appService.appObject.orderObject.claimWelcomePackage && !this.appService.appObject.doNotShowWelcomePackage && this.appService.appObject.settings.main_restaurant
        && this.appService.appObject.settings.main_restaurant.welcome_package_configurations && this.appService.appObject.settings.main_restaurant.welcome_package_configurations.status) {

        // if the user logged in, then check his eligibility of welcome package order
        if (this.appService.appObject.isAuthed) {
          // This line move to top
          // await this.appService.getUserDetails({customer_id:this.appService.appObject.userId});
          if (this.appService.appObject.loggedInUserData && this.appService.appObject.loggedInUserData.eligible_for_welcome_order) {
            // check whether user is invited, if invited we must open password reset ui instead of welcome package
            if (!this.invitedUserEmail && !this.appService.welcomePackageOnTheWayFromDirectLink) this.openWelcomePackagePopUp();
            // if welcomePackageOnTheWayFromDirectLink is true, then open order process to checkout welcome package directly
            else if (this.appService.welcomePackageOnTheWayFromDirectLink) this.presentModal('delivery-type');
          }
        } else {
          // if this is a guest user, then let him put into cart and check eligibility before checkout
          // check whether user is invited, if invited we must open password reset ui instead of welcome package
          if (!this.invitedUserEmail && !this.appService.welcomePackageOnTheWayFromDirectLink) this.openWelcomePackagePopUp();
          // if welcomePackageOnTheWayFromDirectLink is true, then open order process to checkout welcome package directly
          else if (this.appService.welcomePackageOnTheWayFromDirectLink) this.presentModal('delivery-type');
        }

      }

      // if invited user email received, then open password reset ui
      if (this.invitedUserEmail) {
        this.openPasswordResetUIForInvitedUser();
      }

      this.route.queryParams.subscribe((params) => {
        // console.log('params : ', params);
        // this.loadingPointsHistory = true;
        // If 
        if (params.restaurant_id && params.point_history_id && params.payment_status === 'true') {
          // get returned restaurant data and find out success point history record
          this.appService.getPointHistory(params.restaurant_id).then(async (response: any) => {
            // console.log('response : ' , response);

            if (response.status) {
              // this.pointHistory = response.data;
              // this.totalPointCount = response.total_points;

              // console.log('prama : ', param);
              let successPayment = response.data.find((historyOb) => (historyOb.id + '') === (params.point_history_id + ''));
              // console.log('successPayment : ', successPayment);
              if (successPayment) {
                this.successPayment = successPayment;

                const modal = await this.modalController.create({
                  component: InputSelectModalComponent,
                  cssClass: 'select-modal',
                  componentProps: {
                    content: this.rechargeSuccess,
                    // hideFooter:true
                  },
                });
                // hide cart button when popup opening
                this.appService.hideCartButton = true;

                modal.present();
                // console.log(modal);
                modal.onWillDismiss().then(async (event) => {
                  // this.getPointHistory();

                  // when user force to purchase points in checkout process
                  // once the recharge is done redirect back to the selected restaurant menu page and
                  // open checkout process automatically
                  if (successPayment && successPayment.extra_details) {
                    let extraData = JSON.parse(successPayment.extra_details);

                    if (extraData && (extraData.isWebVersion === true || extraData.isWebVersion === 'true') && (extraData.forcedToRecharge === true || extraData.forcedToRecharge === 'true')) {
                      this.router.navigate(['menu', this.appService.appObject.selectedRestaurantDetails.slug], {
                        queryParams: {
                          pointRecharge: true
                        },
                        replaceUrl: true
                      });
                      return;
                    }
                  }

                  // when user close the popup, url must be cleared, otherwise this will trigger again
                  this.router.navigate(['home'], { replaceUrl: true });

                });
              }
            }

          }).catch((error) => {
            console.log('error : ', error);
          }).finally(() => {
            // this.loadingPointsHistory = false;
          });
        }

      });

      // START --------------------------- Praharsha's new design
      if (this.appService.appObject.settings.main_restaurant && this.appService.appObject.settings.main_restaurant.show_social_buttons === 'true') {
        this.displaySocialButtons = true;
        if (this.appService.appObject.settings.main_restaurant.facebook_link) {
          this.facebookLink = this.appService.appObject.settings.main_restaurant.facebook_link;
          let splitted = this.facebookLink.split('/');
          this.facebookUserID = splitted[3] ? splitted[3] : '';
        }

        if (this.appService.appObject.settings.main_restaurant.instagram_link) {
          this.instagramLink = this.appService.appObject.settings.main_restaurant.instagram_link;
          let splitted = this.instagramLink.split('/');
          this.instagramUserID = splitted[3] ? splitted[3] : '';
        }

        if (this.appService.appObject.settings.main_restaurant.pinterest_link) {
          this.pinterestLink = this.appService.appObject.settings.main_restaurant.pinterest_link;
          let splitted = this.pinterestLink.split('/');
          this.pinterestUserID = splitted[3] ? splitted[3] : '';
        }

        if (this.appService.appObject.settings.main_restaurant.youtube_link) {
          this.youtubeLink = this.appService.appObject.settings.main_restaurant.youtube_link;
          let splitted = this.youtubeLink.split('/');
          this.youtubeUserID = splitted[3] ? splitted[3] : '';
          if (this.youtubeUserID[0] !== '@') this.youtubeUserID = ('@' + this.youtubeUserID);
        }

        if (this.appService.appObject.settings.main_restaurant.tiktok_link) {
          this.tiktokLink = this.appService.appObject.settings.main_restaurant.tiktok_link;
          let splitted = this.tiktokLink.split('/');

          // sometimes the link contains query parameters
          // to avoit those values split again
          let splitAgain = splitted[3].split('?');

          this.tiktokUserID = splitAgain[0] ? splitAgain[0] : '';

          if (this.tiktokUserID[0] !== '@') this.tiktokUserID = ('@' + this.tiktokUserID);
        }
      }
      // END --------------------------- Praharsha's new design

      this.checkPointWidgetStatus();
    });

    this.appService.watchUserLoggedInCallback().subscribe((response) =>{
      this.checkPointWidgetStatus();
    });
  }

  /**
   * Will check point configurations 
   */
  checkPointWidgetStatus(){
    // check if points payments are enabled in main restaurant if multiple restaurants are disabled
    if (this.appService.appObject.settings && this.appService.appObject.settings.app_configuration && !this.appService.appObject.settings.app_configuration.has_multiple_restaurants && this.appService.appObject.settings.main_restaurant) {
      let paymentMethods = JSON.parse(this.appService.appObject.settings.main_restaurant.payment_methods);
      if (paymentMethods) {
        let pointsConfig = paymentMethods.find((method) => method.id === 'points');
        if (pointsConfig.isActive === 'true') {
          this.pointsAreEnabled = true;
          this.selectedRestaurant = this.appService.appObject.settings.main_restaurant;
          this.getPointHistory();
          this.checkPointRechargeEnabled();
        } else this.pointsAreEnabled = false;
      }
    }/* else if (this.appService.appObject.settings && this.appService.appObject.settings.app_configuration && this.appService.appObject.settings.app_configuration.has_multiple_restaurants) {
    }*/
    this.getPointsEnabledRestaurantList();

  }

  public goToSocialLink(link) {
    // Check if the link starts with http:// or https://, if not, add https://
    if (!link.startsWith("http://") && !link.startsWith("https://")) {
      link = "https://" + link;
    }
    // Open the link in a new tab
    window.open(link, '_blank');
  }

  /**
   * opens my points model
   */
  async openMyPoints() {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'type': 'my_points',
        'title': 'key.my_points',
        'selectAsDefaultRestaurantInPoints': this.selectedRestaurant.id
      }
    });

    await modal.present();
  }

  /**
 * Open payments modal popup
 */
  async openPaymentModal() {
    const modal = await this.modalController.create({
      component: InputSelectModalPointsComponent,
      cssClass: 'select-modal',
      componentProps: {
        selectedRestaurant: this.selectedRestaurant
      },
    });
    // hide cart button when popup opening
    this.appService.hideCartButton = true;

    modal.present();
    // console.log(modal);
    modal.onWillDismiss().then(async (event) => {
      // this.getPointHistory();
      if (event.data.transaction_status === 'success') {
        this.successPayment = event.data;

        const modal = await this.modalController.create({
          component: InputSelectModalComponent,
          cssClass: 'select-modal',
          componentProps: {
            content: this.rechargeSuccess
          },
        });
        // hide cart button when popup opening
        this.appService.hideCartButton = true;

        modal.present();

        // refresh settings when user close payment success popup
        modal.onDidDismiss().then((res) => {
          this.appService.getSettings();
        })
      }
    });
  }

  async openPasswordResetUIForInvitedUser() {
    let response = await this.appService.checkIsUserImportedAndInvited(this.invitedUserEmail);
    if (response && response.status) {
      const modal = await this.modalController.create({
        component: ModalPopoverPage,
        cssClass: 'order-popup',
        componentProps: {
          'title': 'key.reset_password',
          'type': 'forgot-password',
          'invitedUserEmail': this.invitedUserEmail
        }
      });

      await modal.present();

      modal.onDidDismiss().then((res) => {
        this.appService.code_content = false;
        this.appService.email_content = true;
        this.appService.repeatpass_content = false;
      });
    }
  }

  ngDoCheck() {
    if (this.appService.appObject.theme && this.appService.appObject.theme.web && this.appService.appObject.theme.web.favouriteRestaurantButtonBackground)
      this.favRestaurantIcon = this.appService.appObject.theme.web.favouriteRestaurantButtonBackground;
  }

  /**
   * When the device is not registered before (like in incognito mode in chrome),
   * below api request won't work, so until the device registration process done,
   * have set a timeout to keep check sevaral times wether device registered or not,
   * once it get registered, below api request are good to go
   */
  initWebApp() {
    if (this.appService.appObject.userId) {
      // this.getMostPopularDishes();
      this.fetchMetaData();
    } else if (this.initializeAttempts < 5) { // 5 attempts
      console.log('Waitng till the device get registered (attempt ' + (1 + this.initializeAttempts) + ')');
      setTimeout(() => {
        this.initWebApp();
        this.initializeAttempts++;
      }, 3500);
    }
  }

  ionsliderNext() {
    if (this.slider) this.slider.slideNext();
  }


  ionsliderBack() {
    if (this.slider) this.slider.slidePrev();
  }

  ionViewDidEnter() {
    if (this.slider) this.slider.onlyExternal = true;
    // this.slider.lockSwipes(true);
  }

  getHomeAppImageURL() {
    // + '?randomize=' + new Date().getTime()
    return this.appService?.appObject?.baseUrl + '/images/restaurant-web-home-app-img/' + this.appService?.appObject?.settings?.main_restaurant?.id;
    // return new Date().getTime();
  }

  async presentModal(type) {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': 'key.select_order_type',
        'type': type
      }
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    return data;
  }

  async openPostalAreaSelect() {

    let componentProps = {
      'title': 'key.select_delivery_address',
      'type': 'location-select',
      'await_before_display_content': true
    }

    // get avilable ordering methods
    let availableOrderingMethods = this.appService.findSelectedRestaurantOrderTypesV2(this.appService.appObject.settings.main_restaurant, true);
    // check if delivery is available (delivery method is prioratized by Pumayk26 for this BFF version)
    let isDeliveryAvailable = availableOrderingMethods.deliveryMethods.find((method) => method === 'delivery');
    if (availableOrderingMethods.deliveryMethods.length === 1 && isDeliveryAvailable) {
      this.appService.appObject.selectedDeliveryMethod = 'delivery';

    } else if (availableOrderingMethods.deliveryMethods.length) {
      // if delivery is not available, then check for any method and select first method
      this.appService.appObject.selectedDeliveryMethod = availableOrderingMethods.deliveryMethods[0];
      componentProps.title = 'key.select_order_type';
      componentProps.type = 'delivery-type';
    } else {
      // if there is no any ordering method available just show a message
      this.translate.get('key.unable_to_find_a_ordering_method').subscribe((langT) =>{
        this.appService.showToast(langT, 'danger');  
      })
      // this.appService.showToast('Unable To Find a Ordering Method', 'danger');
      return;
    }

    await this.appService.updateAppObject();

    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: componentProps
    });
    await modal.present();
  }

  /**
   * Fetch web app meta data
   */
  async fetchMetaData() {
    this.appService.appObject.isLoading = true;
    await this.appService.getWebAppLandingPageMetaData().then((response: any) => {
      if (response && response.status) {
        this.metaData = response.data.openDetails ? JSON.parse(response.data.openDetails) : {};
      }
    }).catch((error) => {
      this.metaData = {};
      console.log('Meta Data Error : ', error);
    });
    this.appService.appObject.isLoading = false;
  }

  /**
   * Fetch highlighted product list
   */
  fetchHighlightList() {
    // if franchise mode is on then, fetch highlights from favourite restaurant, otherwise fech from main restaurant
    if (this.appService.isSettingsLoaded && this.appService.appObject.settings.app_configuration
      && (!this.appService.appObject.settings.app_configuration.has_multiple_restaurants || (this.appService.appObject.settings.is_franchise === 'true' && this.appService.appObject.favouriteRestaurant))
      && this.appService.appObject.settings.app_configuration.show_highlights) {
      this.appService.appObject.isLoading = true;
      this.appService.fetchHighlightProducts((this.appService.appObject.settings.is_franchise === 'true' && this.appService.appObject.favouriteRestaurant) ? this.appService.appObject.favouriteRestaurant.id : null).then((response: any) => {
        if (response.status) {
          this.mostPopularDishes = response.data;
        }
        this.appService.appObject.isLoading = false;
      }).catch((error) => {
        this.appService.appObject.isLoading = false;
      })
    }
  }

  /**
   * Fetch all branches
   */
  fetchBranchesList() {
    this.appService.appObject.restaurants = [];
    if (this.appService.isSettingsLoaded && this.appService.appObject.settings.app_configuration && this.appService.appObject.settings.app_configuration.show_branches) {
      this.appService.fetchAllRestaurants(true).then((response) => {
        // if (response === 'done') {
        //   console.log('restaurants : ', this.appService.appObject.restaurants);
        // }
      }).catch((error) => {
        console.log('error : ', error);
      })
    }
  }

  /**
   * User will navigate into selected branch's menu page
   * @param branch selected branch to navigate into
   */
  async navigateToBranchMenu(branch) {
    // clear if any previously added address errors
    this.appService.appObject.errors && this.appService.appObject.errors.address ? this.appService.appObject.errors.address = '' : '';
    if (branch && branch.slug) {
      const modal = await this.modalController.create({
        component: ModalPopoverPage,
        cssClass: 'order-popup',
        componentProps: {
          'title': 'key.select_order_type',
          'type': 'delivery-type',
          'selectedBranch': branch
        }
      });

      await modal.present();
      // this.appService.getRestaurantBySlug(branch.slug).then((response) => {
      //   this.router.navigate(['/menu']);
      // });
    }
  }

  /**
   * Open selected favourite restaurant delivery type select popup
   */
  async openFavouritePopup() {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': 'key.select_order_type',
        'type': 'delivery-type',
        'fromFavouriteIcon': true
      }
    });

    await modal.present();
  }

  async openChangeFavouriteRestaurant() {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': 'key.search_restaurants_nearby',
        'type': 'favourite_restaurant_search',
        'selectfavouriteRestaurant': true
      }
    });

    await modal.present();
  }

  async openWelcomePackagePopUp() {
    // user can stop showing this offer, if do not show enabled, then won't trigger popup
    if (this.appService.appObject.doNotShowWelcomePackage) {
      return;
    }

    // if welcome package offer popup not opened, then pop it up
    if (!this.appService.welcomePackagePopupOpened) {
      this.welcomeOrderPackage = this.appService.appObject.settings.main_restaurant.welcome_package_configurations;
      // this.lanList = this.welcomeOrderPackage.lanList;
      // console.log('this.welcomeOrderPackage : ', this.welcomeOrderPackage);

      this.welcomePopup = await this.modalController.create({
        component: InputSelectModalComponent,
        cssClass: 'select-modal',
        componentProps: {
          content: this.welcomePackageTemplate,
          hideFooter: true
        },
      });

      this.appService.welcomePackagePopupOpened = true;

      await this.welcomePopup.present();

      let response = await this.welcomePopup.onDidDismiss()

      // console.log('response : ',);
      if (response && response.data && response.data.addToCart) {
        this.appService.welcomePackageOnTheWay = true;
        this.presentModal('delivery-type');
      } else {
        this.appService.welcomePackagePopupOpened = false;
      }
    }
  }

  /**
   * Add welcome package to the cart process start
   */
  addToCartWelcomePackage() {
    if (this.welcomePopup) {
      this.appService.welcomePackageOnTheWay = true;
      this.presentModal('delivery-type');
      this.welcomePopup.dismiss();
    } else {
      this.appService.welcomePackagePopupOpened = false;
    }
  }

  /**
   * Welcome package popup do not show tap
   */
  doNotShowAgain() {
    this.appService.appObject.doNotShowWelcomePackage = true;
    this.appService.updateAppObject();
    if (this.welcomePopup) this.welcomePopup.dismiss();
  }

  /**
   * Fetch points history data of the user in selected restaurant
   * @param openPaymentSuccess boolean call openPaymentSuccess function after retriving points history
   */
  async getPointHistory(openPaymentSuccess: boolean = true) {
    this.loadingPointsHistory = true;
    await this.appService.getPointHistory(this.selectedRestaurant.id).then((response: any) => {
      if (response.status) {
        this.pointHistory = response.data;
        this.totalPointCount = response.total_points ? response.total_points.toFixed(2) : 0;

        for (let index = 0; index < this.pointHistory.length; index++) {
          const element = this.pointHistory[index];
          if (element.extra_details) element.extra_details = JSON.parse(element.extra_details);
        }

        // if (openPaymentSuccess) this.openPaymentSuccess();
      }
    }).catch((error) => {
      console.log('error : ', error);
    }).finally(() => {
      this.loadingPointsHistory = false;
    });
  }

  getPointsEnabledRestaurantList() {
    this.appService.getPointsEnabledAllRestaurants().then((pointsEnabledRestaurantsList: any) => {
      if (pointsEnabledRestaurantsList.status) {
        this.pointsEnabledRestaurantList = pointsEnabledRestaurantsList.data;

        if (this.pointsEnabledRestaurantList.length > 0) {
          this.selectedRestaurant = this.pointsEnabledRestaurantList[0];
          this.checkPointRechargeEnabled();
          this.getPointHistory();
        } else {
          this.pointsAreEnabled = false;
        }

        this.loadingPointsHistory = false;
      }
    })
  }

  /**
   * Check whether selected restaurant has points recharge enabled or not
   */
  checkPointRechargeEnabled() {
    if (!this.selectedRestaurant || !this.selectedRestaurant.payment_methods) {
      this.selectedRestaurantRechargeIsEnabled = false;
      return;
    }

    let methods = JSON.parse(this.selectedRestaurant.payment_methods);
    if (methods && methods.length) {
      let pointsRechargeEnabled = methods.find((method) => method.id === 'points' && method.pointsConfigurations && method.pointsConfigurations.points_recharge_enabled == 'true');
      if (pointsRechargeEnabled) this.selectedRestaurantRechargeIsEnabled = true;
      else this.selectedRestaurantRechargeIsEnabled = false;
    } else {
      this.selectedRestaurantRechargeIsEnabled = false;
    }
  }

  /**
   * Will trigger when user change points restaurant
   * @param selectedRestaurant selected restaurant object
   */
  onPointsRestaurantChange(selectedRestaurant) {
    if (selectedRestaurant) {
      this.selectedRestaurant = selectedRestaurant;
      this.checkPointRechargeEnabled();
      this.getPointHistory();
    }
  }
}
